import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { Directive, EventEmitter, inject, input, InputSignal, Output, AfterViewInit, OnDestroy } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { VirtualScrollWrapperComponent } from "@shared/components/virtual-scroll-wrapper/virtual-scroll-wrapper.component";
import { debounceTime, filter, Observable, Subject, takeUntil } from "rxjs";

@Directive({
  selector: "app-virtual-scroll-wrapper[appInfiniteScroll]",
  standalone: true
})
export class InfiniteScrollDirective implements AfterViewInit, OnDestroy {
  private readonly _scrollWrapper: VirtualScrollWrapperComponent = inject(VirtualScrollWrapperComponent);

  private _scrollViewport: Observable<CdkVirtualScrollViewport> = toObservable(this._scrollWrapper.scrollViewport)
    .pipe(
      filter(Boolean)
    );

  /**
   * Emits an event when the scroll buffer limit is reached.
   */
  @Output() public readonly scrollBufferReach: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Defines the distance (in pixels) from the bottom that triggers the buffer event.
   */
  public scrollBufferSize: InputSignal<number> = input(0);

  /**
   * Time in milliseconds to debounce scroll events.
   */
  public scrollDebounceTime: InputSignal<number> = input(300);


  private _destroy$: Subject<void> = new Subject<void>();

  ngAfterViewInit (): void {
    this._scrollViewport.pipe(
      takeUntil(this._destroy$)
    ).subscribe({
      next: (viewPort: CdkVirtualScrollViewport) => {
        this.initScrollBufferListener(viewPort);
      }
    });
  }


  ngOnDestroy (): void {
    this._destroy$.next();
  }

  private initScrollBufferListener (viewPort: CdkVirtualScrollViewport): void {
    const scrollOffset: number = viewPort.measureScrollOffset("bottom");

    if (scrollOffset === 0)
      this.scrollBufferReach.emit();

    viewPort.elementScrolled()
      .pipe(
        debounceTime(this.scrollDebounceTime()),
        takeUntil(this._destroy$)
      )
      .subscribe(() => {
        const offset: number = viewPort.measureScrollOffset("bottom");

        if (offset < this.scrollBufferSize())
          this.scrollBufferReach.emit();
      });
  }
}

